<div class="activity-feeds" *ngIf="activityFeeds.length > 0 && validateFeedsInfo">
  <particle-activity-feed
    *ngFor="let feed of activityFeeds; index as i"
    [data]="feed"
    [showChatEditor]="feed.showChatEditor"
    [isExpanded]="feed.id === expandedFeedInfo"
    [filterSettings]="filterSettings"
    [changeNotificationSettingsEvent$]="changeNotificationSettingsEvent$"
    (activityFeedInfoEvent$)="handleActivityFeedInfoEvent($event)"
    (expandedInfoEvent$)="handleExpandedInfoEvent($event)">
  </particle-activity-feed>
</div>
<div class="activity-feeds" *ngIf="activityFeeds.length === 0">
  <particle-activity-feed
    [data]="data"
    [showChatEditor]="showChatEditor"
    (activityFeedInfoEvent$)="handleActivityFeedInfoEvent($event)">
  </particle-activity-feed>
</div>
